<template>
  <a-select
    :value="currentLang"
    class="dash-text__16 dash-text__400 main-lang-select"
    dropdownClassName="main-lang-select__dropdown"
    @select="changeLang"
  >
    <a-select-option v-for="lang in langs" :key="lang.id" :value="lang.id">
      {{ lang.id.toUpperCase() }}
    </a-select-option>
  </a-select>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["langs", "currentLang"]),
  },
  methods: {
    changeLang(lang) {
      this.$store.dispatch("updateCurrentLang", lang);
      this.$debug("Изменен язык, текущий: " + lang, "warning");
      this.$i18n.locale = lang;
      window.location.reload();
    },
  },
};
</script>
